import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";

const initialState = {
  totallPcn: [],
  isLoading: false,
};

export const getAllPcn:any = createAsyncThunk("pcns/getpcn", async (endPoint:string) => {
    const response = await ApiClient.get(endPoint);
    return response.data;
});

const pcnSlice = createSlice({
  name: "pcns",
  initialState,
  reducers: {
    pcnData(state, action) {
      state.totallPcn = action.payload;
    },
  },
  extraReducers: {
    [getAllPcn.pending]: (state: any) => {
      state.isLoading = true;
    },
    [getAllPcn.fulfilled]: (state: any, actions: any) => {
      state.isLoading = false;
      state.totallPcn = actions.payload;
    },
    [getAllPcn.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { pcnData } = pcnSlice.actions;
export default pcnSlice;
